import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; 
import './DiscoverButton.css';

interface DiscoverButtonProps {
  link: string; 
}

const DiscoverButton: React.FC<DiscoverButtonProps> = ({ link = '#' }) => {
  
  const { t } = useTranslation();

  return (
    <Link to={link} className="discover-btn">
      {t('buttons:discoverMore')}
    </Link>
  );
};

export default DiscoverButton;